export default class EquipmentTypeElem {
  /**
   * Définition of a type for and EquipmentTypeDto and a quantity of it
   * @param {EquipmentTypeDto} equipmentTypeDto the equipment type dto
   * @param {quantity} quantity the amount of this equipment type
   */
  constructor({
                equipmentTypeDto,
                quantity
              }) {
    this.equipmentTypeDto = equipmentTypeDto;
    this.quantity = quantity;
  }
}
